import Init from '../../../extendable/Init';
import './Default.scss';

const Default = () => {

};

Init(Default);
